import { Canvas } from '../models/Canvas'

// Make this a Map when: https://github.com/sveltejs/svelte/issues/9761

/** @type {Record<number, Canvas>} */
export const canvases = $state({})
